import {getJson, postJson} from "@/ajax/http";
import store from "@/store";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { ContentManageApiUrl, SiteCode } from "@/config/sys.config";

const getApiUrl = () => {
    const { ApiUrl } = store.state.business.sysConfig;
    const pageId = store.state.business.pageId;
    const pageCode = store.state.business.pageCode;
    if (pageId || pageCode) {
        return ContentManageApiUrl + "/dify";
    } else {
        return ApiUrl;
    }
}

const getAuthHeaders = () => {
    const { ApiToken } = store.state.business.sysConfig;
    const pageId = store.state.business.pageId;
    const pageCode = store.state.business.pageCode;
    if (pageId || pageCode) {
        return {
            "X-Dify-PageId": pageId || "",
            "X-Dify-PageCode": pageCode,
            "X-Dify-ModuleCode": "ZNWD_PRIVATE",
            "X-Dify-SiteCode": SiteCode
        }
    } else {
        return {
            "Authorization": "Bearer " + ApiToken, // 鉴权
        }
    }
}

export const chatApi = {
    startChat: (data) => {
        const ApiUrl = getApiUrl();
        const headers = getAuthHeaders();
        return fetchEventSource(ApiUrl + "/chat-messages", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...headers // 鉴权
            },
            ...data
        });
    },
    stopChat: (taskId, data) => {
        const ApiUrl = getApiUrl();
        const url = ApiUrl + `/chat-messages/${taskId}/stop`;
        const headers = getAuthHeaders();
        return postJson(url, data, headers);
    },
    feedBackMessage: (messageid, rating, content, userId) => {
        const ApiUrl = getApiUrl();
        const url = ApiUrl + "/messages/" + messageid + "/feedbacks";
        const data = {
            rating: rating,
            user: userId,
            content: content,
        };
        const headers = getAuthHeaders();
        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...headers
            },
            body: JSON.stringify(data),
        };
        fetch(url, options)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json(); // 将响应数据解析为 JSON 格式
            })
            .then((data) => {
                if (data.result === "success" && rating == "like") {
                    console.log("喜欢保存成功"); // 弹出调用成功的提示
                } else if (data.result === "success" && rating == "dislike") {
                    console.log("不喜欢保存成功"); // 弹出调用成功的提示
                }
            })
            .catch((error) => console.error("Error:", error));
    },
    getConversation: (data) => {
        const ApiUrl = getApiUrl();
        const url = ApiUrl + `/messages`;
        const headers = getAuthHeaders();
        return getJson(url, data, headers);
    },
}
